var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9499 6.00098H15.75C16.5785 6.00098 17.25 6.67255 17.25 7.50096V9.07926C17.25 9.27516 17.2116 9.46918 17.1371 9.65038L14.8162 15.2866C14.7005 15.5676 14.4266 15.751 14.1227 15.751H1.5C1.08579 15.751 0.75 15.4152 0.75 15.001V7.50096C0.75 7.08676 1.08579 6.75098 1.5 6.75098H4.11138C4.35508 6.75098 4.58357 6.63258 4.72411 6.43349L8.81415 0.639249C8.92103 0.487847 9.12248 0.437216 9.28823 0.520095L10.6488 1.20036C11.4375 1.59474 11.8448 2.48542 11.6273 3.33999L10.9499 6.00098ZM5.25 7.94158V14.251H13.6205L15.75 9.07926V7.50096H10.9499C9.97132 7.50096 9.25485 6.57919 9.4962 5.63091L10.1737 2.96994C10.2172 2.79902 10.1357 2.62088 9.97792 2.54201L9.4821 2.29408L5.94956 7.29852C5.76214 7.56403 5.52256 7.78168 5.25 7.94158ZM3.75 8.25096H2.25V14.251H3.75V8.25096Z",
    fill: "#026094"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.10cf01a0257cb031457e8bc1833b06cc.svg";
export { ForwardRef as ReactComponent };